// index.tsx
//
// Roteador da aba "Descontos e Taxas". Mesmo formato do storesSection: um
// switch em `selectedVerticalOption` e o mesmo default de "Sessão não
// encontrada" — inclusive o texto, porque duas telas de erro diferentes para o
// mesmo erro só ensinam o usuário a achar que quebrou de dois jeitos.
//
// ATENÇÃO, o mesmo alerta do shell: aba nova exige TRÊS edições casadas, por
// string, sem type-check ligando as três — `horizontalOptions`, a chave de
// `verticalOptions` e o `case` de `renderSessionContent`, todos em
// configuration/index.tsx. As duas primeiras já existem ("Descontos e Taxas" →
// ["Descontos", "Taxas"]); enquanto o `case` não existir, esta section não é
// montada por ninguém e a aba cai no default do shell.

import React from "react";
import Descontos from "./Descontos";
import Taxas from "./Taxas";

interface DescontosSectionProps {
  selectedVerticalOption: string;
  decryptedInfoToken: any;
  // A implementação real é (objectType, payload?) e devolve
  // { ok, tom, texto } | null — ver configuration/index.tsx.
  handleSave: (objectType: any, payload?: any) => any;
  handleOpenModal: (type: string, object?: any) => void;
  updateState: (newState: any) => void;
}

const DescontosSection: React.FC<DescontosSectionProps> = ({
  selectedVerticalOption,
  decryptedInfoToken,
  handleSave,
}) => {
  switch (selectedVerticalOption) {
    case "Descontos":
      return (
        <Descontos
          decryptedInfoToken={decryptedInfoToken}
          handleSave={handleSave}
        />
      );
    case "Taxas":
      return (
        <Taxas
          decryptedInfoToken={decryptedInfoToken}
          handleSave={handleSave}
        />
      );
    default:
      return (
        <div
          style={{
            padding: "var(--sp-40)",
            textAlign: "center",
            color: "#6c757d",
          }}
        >
          <div style={{ fontSize: "var(--fs-6xl)", marginBottom: "var(--sp-16)" }}>🔍</div>
          <div style={{ fontSize: "var(--fs-lg)", marginBottom: "var(--sp-8)" }}>
            Sessão não encontrada
          </div>
          <div style={{ fontSize: "var(--fs-md)" }}>{selectedVerticalOption}</div>
        </div>
      );
  }
};

export default DescontosSection;
